import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Wrapper } from '@catalogo/theme-wrapper';
import { Stars } from '@catalogo/theme-stars';
import { Nav } from '@catalogo/core-nav';
import withFilter from '@catalogo/service-americanas-product-review/src/legacy/hocs/withFilter';
import RatingDistribution from '../components/rating-distribution';
import FilterInput from './filter-input';

const around = number => Math.round(number * 100) / 100;

const RecommendValuation = ({ stateRating, ratingDistribution, rating, onChangeRating, ratingOptions }) => (
  <WrapperRatingContent>
    <WrapperRating>
      <RatingValue>{around(rating.average)}</RatingValue>
      <Stars rating={rating.average} size={21} gapBetweenStars={2} />
      {rating.reviews > 1 ? (
        <ReviewsValue>baseada em {rating.reviews} avaliações</ReviewsValue>
      ) : (
        <ReviewsValue>baseada em {rating.reviews} avaliação</ReviewsValue>
      )}
    </WrapperRating>
    <RatingDistribution
      stateRating={stateRating}
      ratingOptions={ratingOptions}
      onChangeRating={onChangeRating}
      ratingDistribution={ratingDistribution}
    />
  </WrapperRatingContent>
);

const RecommendContent = ({ recommended, productId }) => (
  <WrapperRecommendContent>
    <WrapperRecommend>
      <RecommendNumber>{recommended}%</RecommendNumber>
      <RecommendText>dos clientes recomendam esse produto</RecommendText>
    </WrapperRecommend>
    <Button to={`/avaliacao/${productId}`}>Avaliar produto</Button>
  </WrapperRecommendContent>
);

const RenderFeedbackNoReview = ({
  starCountFeedback,
  onChangeRating,
  resetFilter = { filter: null, name: 'todas as notas', label: '' },
}) => (
  <FeedbackWrapper>
    <TextFeedback>O produto não possui nenhuma avaliação {starCountFeedback}</TextFeedback>
    <ButtonFeedbackFilter onClick={() => onChangeRating(resetFilter)}>veja todas as avaliações</ButtonFeedbackFilter>
  </FeedbackWrapper>
);
const Filters = ({ ratings, sort, onChangeRating, onChangeSort, stateRating }) => {
  const [showRating, setShowRating] = useState(false);
  const [showSort, setShowSort] = useState(false);

  const toggleFilter = name => {
    switch (name) {
      case 'filter-sort':
        setShowSort(!showSort);
        break;
      case 'filter-rating':
        setShowRating(!showRating);
        break;
    }
  };

  useEffect(
    () => () => {
      setShowRating(false);
      setShowSort(false);
    },
    []
  );

  useEffect(() => {
    if (showSort) {
      setShowRating(false);
    }
  }, [showSort]);

  useEffect(() => {
    if (showRating) {
      setShowSort(false);
    }
  }, [showRating]);

  return (
    <>
      <FilterInput
        name="filter-rating"
        stateRating={stateRating}
        filters={ratings}
        onChange={onChangeRating}
        show={showRating}
        toggleFilter={toggleFilter}
      />
      <FilterInput
        name="filter-sort"
        filters={sort}
        onChange={onChangeSort}
        show={showSort}
        toggleFilter={toggleFilter}
      />
    </>
  );
};

export const Header = ({
  rating,
  productId,
  recommended,
  sortOptions,
  ratingsOptions,
  onChangeRating,
  onChangeSort,
  starCountFeedback,
  stateRating,
  stateSort,
  setFilterLoadMore,
  ratingDistribution,
  reviews,
}) => {
  useEffect(() => {
    setFilterLoadMore(stateRating.filter, stateSort.filter);
  }, [stateRating, stateSort]);

  return (
    <Wrapper>
      <RecommendValuation
        stateRating={stateRating}
        rating={rating}
        onChangeRating={onChangeRating}
        ratingDistribution={ratingDistribution}
        ratingOptions={ratingsOptions}
      />
      <RecommendContent recommended={recommended} productId={productId} />
      <WrapperFilter>
        <Filters
          stateRating={stateRating}
          ratings={ratingsOptions}
          sort={sortOptions}
          onChangeRating={onChangeRating}
          onChangeSort={onChangeSort}
        />
      </WrapperFilter>
      {reviews.length < 1 && (
        <RenderFeedbackNoReview starCountFeedback={starCountFeedback} onChangeRating={onChangeRating} />
      )}
    </Wrapper>
  );
};

export default withFilter(Header);

const WrapperRatingContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 15px;
  margin: 0 16px;
  border-bottom: 1px solid ${({ theme }) => theme.grey.light};
`;

const WrapperRating = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.grey.medium};
`;

const WrapperRecommendContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 0 16px;
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
`;

const WrapperRecommend = styled.div`
  display: flex;
`;

const RatingValue = styled.div`
  font-weight: 700;
  font-size: 58px;
  color: #4e4e4e;
`;

const ReviewsValue = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.grey.dark};
  margin-top: 5px;
`;

const Button = styled(Nav)`
  outline: 0;
  padding: 0;
  width: 100px;
  height: 43px;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  border-radius: 8px;
  background: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.primaryColor};
  border: 2px solid ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 10px;
`;

const RecommendNumber = styled.div`
  background-color: #ffc900;
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  padding: 0 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RecommendText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.grey.dark};
  width: 100%;
  max-width: 130px;
  line-height: 15px;
  margin-left: 10px;
`;

const ButtonFeedbackFilter = styled.button`
  font-size: 14px;
  background: none;
  color: #666666;
  font-style: normal;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 10px;
  border: none;
  outline: none;
`;

const TextFeedback = styled.span`
  font-style: normal;
  font-weight: bold;
  display: block;
  font-size: 18px;
  line-height: 24px;
  color: #666666;
`;

const FeedbackWrapper = styled.div`
  text-align: center;
  padding: 7px 15px 25px;
`;

const WrapperFilter = styled.div`
  display: flex;
  column-gap: 8px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px;
  position: relative;
`;
